import { render, staticRenderFns } from "./StudioCreationForm.vue?vue&type=template&id=46bca9ae"
import script from "./StudioCreationForm.vue?vue&type=script&lang=js"
export * from "./StudioCreationForm.vue?vue&type=script&lang=js"
import style0 from "./StudioCreationForm.vue?vue&type=style&index=0&id=46bca9ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports